import React, { lazy, Suspense } from 'react';
import NavbarComponent from './Navbar';
import styled, { createGlobalStyle } from 'styled-components';
import { Container } from 'react-bootstrap';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap');

  body {
    font-family: 'Poppins', sans-serif;
    background: linear-gradient(to right, #f5f7fa, #c3cfe2);
  }
`;

const FooterInsert = lazy(() => import('./FooterInsert'));

const PrivacyContainer = styled(Container)`
  margin-top: 300px;
  margin-bottom: 100px;
`;
const StyledParagraphTitle = styled.h6`
  text-decoration: underline;
`;
const StyledTitle = styled.h1`
  font-weight: bold;
`;

const Privacy_policy = () => {
  return (
    <div>
      <GlobalStyle />
      <NavbarComponent />
      
      <PrivacyContainer>
        <h1>Privacy Policy</h1>
         <br/>
        <div>
          <p>When collecting the data specified in this privacy policy, we, Retail Park Limited, are the Data Controllers. This policy has been produced in line with the UK General Data Protection Regulation (UK GDPR), the Data Protection Act 2018 (DPA 2018) and the Human Rights Act 1998 (HRA 1998).</p>
          <p>Please note that this policy can also be obtained by visiting <a href="https://www.retailparkuk.co.uk/privacy" target='_blank' rel="noreferrer">www.retailparkuk.co.uk/privacy</a></p>
        </div>
        <br/>
        <div>
          <StyledParagraphTitle>What data is processed?</StyledParagraphTitle>
          <p>Entry into the car park may result in your personal data being obtained, retained and processed. The data processed may include the vehicle registration mark, tie and movements of your vehicle and images of your vehicle.</p>
        </div>
        <br/>
        <div>
          <StyledParagraphTitle>The purpose of the processing of this data is:</StyledParagraphTitle>
          <ol className="list-decimal">
            <li>To ensure compliance with your obligations under the contractual agreement entered into when your vehicle entered and remained on the car park and for the legitimate purpose of pursuing the driver and/or any other party who may become liable for the payment of any Parking Charge.</li>
            <li>To deter criminal activity on the car park and to help detect crimes which may have been committed on this private land?</li>
          </ol>
        </div>
         <br/>
        <div>
          <StyledParagraphTitle>Our lawful basis for the processing of data is:</StyledParagraphTitle>
          <ol className="list-decimal">
            <li>The data processing is necessary for a contract which has been entered into.</li>
            <li>There is a legitimate interest as follows:
              <ol>
                <li>To pursue motorists for unpaid parking tariffs.</li>
                <li>To pursue the motorist for unpaid Parking Charge Notices (PCN’s).</li>
                <li>To ensure safety and security and assist to deter/detect crimes.</li>
              </ol>
            </li>
          </ol>
        </div>
         <br/>
        <div>
          <StyledParagraphTitle>How long will we keep your personal data?</StyledParagraphTitle>
           <p>Where there is a fee that is payable we may request personal details of the registered keeper of the vehicle the DVLA and additional third parties (for example the registered keeper providing drivers details or hire/lease companies where applicable) who may possess information which could assist in resolving any relevant disputes.</p>
           <p>Where your data is obtained it will be retained for 6 months where there is no unpaid fee outstanding. Where there is an unpaid fee the data obtained will be held for sufficient time to enable the fee outstanding to be settled, by you or another individual and resolve any dispute. However, in most cases your data will not normally be held for longer than 6 years. Examples of when we may on occasion hold your data for longer are;</p>
          <ol className="list-decimal">
            <li>When there is an on-going dispute which requires us to hold the data for longer than the normal period.</li>
            <li>Where in the event a court order has been made allowing us to pursue outstanding monies after the expiration of 6 years.
            </li>
          </ol>
        </div>
         <br/>
        <div>
          <StyledParagraphTitle>Who do we share data with?</StyledParagraphTitle>
           <p>Your personal data may be shared with third party. This may include debt recovery companies, solicitors and bailiffs to pursue any outstanding debts. If you decide to challenge a Parking Charge Notice and we reject your challenge/appeal, then we will provide your vehicle registration number and Parking Charge Notice reference number along with the time and the date of the parking contravention to them. This is to allow you to contest the decision made in regards to the PCN with an independent adjudicator.</p>
        </div>
         <br/>
        <div>
          <StyledParagraphTitle>Your rights </StyledParagraphTitle>
           <p>Please email us at <a href='mailto:dataprotection@retailparkuk.co.uk' >dataprotection@retailparkuk.co.uk</a> (ensure you provide proof of identification when emailing) if:</p>
          <ol className="dash-list">
            <li>You want to access personal data</li>
            <li>You object to your personal details being processed.</li>
            <li>You believe that we hold the incorrect details for you and wold like to rectify the data we hold.</li>
            <li>You wish the data we hold for you to be deleted.</li>
            <li>You would like to restrict how we process your data.</li>
            <li>If you entered into a contract with us and would like a copy of the data we hold for you and your vehicle in a format which can easily be transferred to another provider.</li>
          </ol>
           <p>Please be advised that you have the right to request the above, however, when we receive your request we may object if we do not agree with the request. However if you make the request we will inform you if your request has been successful or not.</p>
        </div>
      </PrivacyContainer>

      <Suspense fallback={<div>Loading...</div>}>
        <FooterInsert />
      </Suspense>
    </div>
  );
};

export default Privacy_policy;
